﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Assinatura",
  "change": "Alterar",
  "currency": "USD",
  "save": "Salvar",
  "save17Percent": "<strong>Economize {{percent}}%</strong> com um plano anual",
  "save17PercentNoBold": "Economize {{percent}}%",
  "yearly": "Anual",
  "monthly": "Mensal",
  "Lifetime": "Vida útil",
  "PerMonth": "Por Mês",
  "PerYear": "Por Ano",
  "Free": "Grátis",
  "optional": "opcional",
  "trialLengthTrial": "<0>{{ trialLength }}</0>dia(s) de teste",
  "viewAllPlans": "Visualizar todos os planos",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canadá",
  "unitedStates": "Estados Unidos",
  "oneMomentPlease": "Um momento, por favor...",
  "software": "Software",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Completo",
  "loadingRegions": "Carregando regiões disponíveis",
  "loadingPartners": "Carregando parceiros disponíveis",
  "supportedPeripherals": "Periféricos compatíveis",
  "pleaseWait": "Aguarde...",
  "minimum": "Mínimo",
  "recommended": "Recomendado",
  "browser": "Navegador",
  "tobiiDynavoxEyeTrackers": "Tobii Dynavox Eye Trackers",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "preciso de ajuda para escolher",
  "or": "ou",
  "advantages": "Vantagens",
  "visitPartnerSite": "Visite o site do parceiro",
  "recentOrders": "Pedidos recentes",
  "current": "atual",
  "orLater": "ou mais tarde",
  "customerSupport": "suporte ao cliente",
  "proratedAmount": "Valor proporcional",
  "community": {
    "community": "Comunidade",
    "getStartedNow": "Comece agora mesmo!"
  },
  "personal": "Pessoal",
  "professional": "Profissional",
  "planCard": {
    "noCCRequired": "Não é necessário cartão de crédito",
    "cCOnly": "Apenas cartão de crédito",
    "cCOrPO": "Cartão de crédito ou ordem de compra",
    "myPlan": "Meu plano",
    "currentPlan": "Plano atual",
    "downgradeNotice": "As alterações entrarão em vigor quando o plano atual expirar.",
    "upgradeNotice": "A alteração entrará em vigor imediatamente."
  },
  "selectedPlanSummary": {
    "summary": "Sumário",
    "change": "$t(change)",
    "subtotal": "Subtotal"
  },
  "action": {
    "joinToday": "Cadastre-se hoje mesmo!",
    "finish": "Concluir",
    "subscribe": "Assinar",
    "resubscribe": "Renovar assinatura",
    "requestAQuote": "Solicite um orçamento",
    "try": "Experimentar",
    "startTrial": "Iniciar versão de teste",
    "buyNow": "Comprar Agora",
    "tryIt": "Experimentar",
    "tryItFree": "Experimente grátis por 30 dias!",
    "free": "gratuito",
    "getStarted": "Vamos começar!",
    "forTrialDays": "por <1>{{trialLength}}</1> dias",
    "comparePlans": "Comparar planos",
    "hideComparisons": "Ocultar comparações",
    "learnMore": "Saiba mais",
    "start": "Iniciar",
    "next": "Próximo",
    "edit": "Editar",
    "cancel": "Cancelar",
    "imTaxExempt": "Isenção de impostos",
    "submit": "Enviar",
    "print": "Imprimir",
    "backToPaymentDetails": "Voltar para as informações de pagamento",
    "close": "Fechar",
    "back": "Voltar",
    "continue": "Continuar",
    "uploading": "Fazendo upload",
    "delete": "Excluir",
    "update": "Atualizar",
    "generatingInvoice": "Gerando fatura",
    "proceed": "Avançar",
    "modify": "Modificar",
    "yes": "Sim",
    "signUp": "Inscrever-se",
    "downloads": "Downloads"
  },
  "status": {
    "loading": "Carregando…",
    "creatingAccount": "Criando conta...",
    "submitting": "Enviando...",
    "submittingPayment": "Enviando pagamento...",
    "submittingRequest": "Enviando solicitação..."
  },
  "planComparison": {
    "label": "Quais são os benefícios de cada plano?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Comparação de recursos",
    "subheader": "A solução preferida do mundo inteiro para criar infinitas formas de comunicação baseadas em símbolos e auxílios visuais!"
  },
  "account": {
    "email": "E-mail",
    "accountFoundTitle": "Conta encontrada",
    "accountFoundMessage": "Já existe uma conta cadastrada neste e-mail. Gostaria de fazer login usando esta conta ou usar um e-mail diferente e criar uma nova conta?",
    "signedOutElsewhereTitle": "Você foi desconectado",
    "signedOutElsewhereMessage": "Você foi desconectado em outra aba. Faça login novamente para continuar, ou feche esta mensagem para continuar navegando sem uma conta.",
    "signedOutElsewhereDismiss": "Continuar navegando",
    "federatedEmailTitle": "E-mail da organização detectado",
    "federatedEmailMessage": "Este endereço de e-mail usa o login da sua organização. Faça login para acessar o Boardmaker pela sua organização ou use outro endereço de e-mail para criar uma nova conta.",
    "federatedEmailUseDifferent": "Usar outro e-mail",
    "logIn": "Entrar",
    "logOut": "Sair",
    "loggingIn": "Entrando...",
    "loggingOut": "Saindo...",
    "verifying": "Verificando...",
    "loggingInMessage": "Permitindo acesso...",
    "createAccount": "Criar conta",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Já possui uma conta ",
    "login2": "Tobii Dynavox",
    "login3": "?",
    "loginPrompt": "Já possui uma <1>conta Tobii Dynavox</1>? <3>Fazer login</3>",
    "cancelSubscription": "Cancelar assinatura",
    "areYouSure": "Tem certeza de que deseja selecionar este plano? Prosseguir fará o seguinte:",
    "cancelSubscriptionProcess": "Cancelar o processo de assinatura (seu progresso atual será perdido)",
    "changeToCommunityPlan": "Alterar sua conta para um plano Comunidade",
    "onceYouveCompletedYourProfile": "Após concluir o seu perfil, é possível atualizar o seu plano a qualquer momento na seção Minha conta.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Recuperação das informações do usuário"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Preencha os campos abaixo e um gerente de contas entrará em contato com você o mais breve possível.",
    "fillOutDetailsBelowLicense": "Preencha os campos abaixo e um consultor de vendas entrará em contato com você o mais breve possível."
  },
  "forms": {
    "confirmEmail": "Confirmar e-mail",
    "billingDetails": "Detalhes de faturamento",
    "paymentType": "Tipo de pagamento",
    "creditCardType": "Tipo de pagamento",
    "creditCard": "Cartão de crédito",
    "purchaseOrder": "Ordem de compra",
    "cardNumber": "Número do cartão",
    "expirationDate": "Data de validade",
    "cardholderName": "Nome do titular do cartão",
    "cardSecurityCode": "Código de segurança do cartão",
    "securityCode": "Código de segurança ",
    "organizationName": "Nome da instituição",
    "accountsPayableEmail": "E-mail de contas a pagar",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "addressLine": "Barra de Endereço 1",
    "addressLine2": "Barra de Endereço 2",
    "country": "País",
    "language": "Idioma",
    "city": "Cidade",
    "stateProvinceRegion": "Estado/Província/Região",
    "zipPostalCode": "CEP/Caixa Postal",
    "month": "Mês",
    "year": "Ano",
    "optional": "opcional",
    "username": "Nome de Usuário",
    "name": "Nome",
    "phoneNumber": "Telefone",
    "phone": "Telefone",
    "email": "E-mail",
    "url": "URL",
    "selectYourCountry": "Selecione seu país",
    "selectYourState": "Selecione seu estado",
    "selectYourProvinceTerritory": "Selecione sua província ou território",
    "selectYourTerm": "Selecione a duração do seu plano",
    "1year": "1 ano",
    "2years": "2 anos",
    "3years": "3 anos",
    "4years": "4 anos",
    "5years": "5 anos",
    "instructorLogins": "Número de logins do(a) instrutor(a)",
    "studentLogins": "Número de logins do(a) aluno(a)",
    "term": "Termo",
    "tradeIn": "Qualificado para descontos de troca?",
    "legacyVersions": "Você possui versões mais antigas do Boardmaker para trocar por um desconto no preço do myBoardmaker?",
    "selectAResponse": "Selecione uma resposta",
    "yes": "Sim",
    "no": "Não",
    "notSure": "Não tenho certeza",
    "password": "Senha",
    "confirmPassword": "Confirmar senha",
    "additionalInformationOrQuestions": "Informações adicionais ou Dúvidas",
    "countryNotSupported": "---",
    "uploadDocument": "Fazer upload do documento",
    "chooseFile": "Selecionar arquivo",
    "paymentMethod": "Método de pagamento",
    "purchaseOrdersAreOnlyProcessed": "As ordens de compra só são processadas após o envio do seu pedido. Assim, ela podem ser modificadas a qualquer momento antes do envio.",
    "PONumber": "Número da ordem de compra",
    "PONotes": "Informações adicionais da Instituição",
    "iVerifyThatImAuthorized": "Certifico que estou autorizado a enviar esta ordem de compra.",
    "submissionSuccessful": "Envio realizado com sucesso!",
    "thankYourForYourRequest": "Agradecemos a sua solicitação! Um gerente de contas entrará em contato com você em breve;",
    "ccExpDateFormat": "MM/AAAA",
    "numberOfLicenses": "Número de licenças",
    "pleaseEnterYourName": "Digite seu nome exatamente como aparece no cartão",
    "needHelpFindingSecurityCode": "Preciso de ajuda para encontrar o código de segurança do seu cartão"
  },
  "validation": {
    "required": "Obrigatório",
    "invalidEmail": "E-mail inválido",
    "emailsMustMatch": "Os e-mails devem ser iguais",
    "passwordsMustMatch": "As senhas devem ser iguais",
    "errorOccurred": "Ocorreu um erro no envio do formulário",
    "tryAgain": "Tente novamente. Se o problema continuar, entre em contato com o suporte.",
    "errorOccurredPDF": "Ocorreu um erro no carregamento do PDF da fatura",
    "password": {
      "minLength": "A senha deve ter no mínimo 8 caracteres",
      "tooShort": "Curta demais",
      "checking": "Verificando..."
    },
    "USZipCode": "Precisa inserir um código postal dos EUA",
    "CAZipCode": "Precisa inserir um código postal do Canadá.",
    "invalidCardNumber": "O número do cartão é inválido",
    "invalidCardType": "O tipo do cartão é inválido",
    "invalidExpirationDate": "A data de validade do cartão é inválida",
    "invalidSecurityCode": "O código de segurança é inválido",
    "securityCodeNumericWarning": "O código de segurança deve conter apenas números",
    "invalidUsernameWarning": "O nome de usuário é inválido. Deve conter apenas letras e números.",
    "usernameMaxLengthWarning": "O nome de usuário não pode ter mais de 60 caracteres",
    "badZip": "O CEP informado é inválido para o estado selecionado.",
    "badPostalCode": "O Código postal informado é inválido para a província ou território selecionado.",
    "canadianAddressNeedsCad": "Endereços de cobrança canadenses são cobrados em dólares canadenses. Para continuar, selecione a bandeira na parte superior da página e, depois, escolha Canadá."
  },
  "invoice": {
    "communityHeader": "Sem cartão de crédito. Apenas acesso grátis à myBoardmaker Community. Mantenha seus dados e progresso caso decida atualizar para uma assinatura paga. O que está esperando?",
    "trialHeader": "Sem restrições. Sem cartão de crédito. Mantenha seus dados e progresso caso decida transformar seu teste em uma assinatura paga. O que está esperando?",
    "plan": "Plano",
    "term": "Termo",
    "price": "Preço",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Informações de pagamento",
    "endingWith": "Termina com",
    "expires": "Expira",
    "orderSummary": "Índice de pedidos",
    "orderDate": "Data do Pedido",
    "orderNumber": "Número do Pedido",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Imposto",
    "total": "Total",
    "aConfirmationEmail": "Um e-mail de confirmação do pedido foi enviado para",
    "printOrderSummary": "Imprimir índice de pedidos",
    "recurringPaymentDisclaimer": "Seu pedido inclui um <strong>pagamento recorrente</strong> no valor de <3> que será renovado em {{amount}}</3> que será renovado em <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Cobraremos <strong>{{amount}}</strong> em <strong>{{date}}</strong>, quando seu novo plano começar.",
    "PODisclaimer": "Sua assinatura foi ativada e está pronta para ser utilizada. Para evitar interrupções em seu serviço, seu pagamento deverá ser feito dentro de <strong>30 dias</strong>. Caso o pagamento não seja recebido dentro de <4>{{date, LL}}</4> , sua conta será transformada em uma conta gratuita na comunidade até a efetuação do pagamento.",
    "purchaseOrderNumber": "Número da ordem de compra",
    "orgNotes": "Informações adicionais da Instituição",
    "pleaseSendACopyOfYourInvoice": "Envie seu pagamento e uma cópia da sua fatura para:",
    "ifYourPurchaseOrdersReady": "Você pode fazer o upload da sua ordem de compra agora, caso esteja pronta.",
    "supportedFileTypes": "Tipos de arquivo suportados:.pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Quando chegar a hora, enviaremos um e-mail para <1>{{email}}</1> lembrando você da data de vencimento do próximo pagamento.",
    "uploadSuccessful": "Upload realizado com sucesso!",
    "yourAccountWillContinue": "Agradecemos seu pedido de compra. Para renovações de assinatura, aguarde até 14 dias para que seu pedido seja processado. Quando concluído, você receberá um e-mail confirmando a conclusão, juntamente com sua fatura.",
    "billing": "Endereço de cobrança",
    "payment": "Método de pagamento",
    "ifYourPurchaseOrderIsReady": "Você pode fazer o upload da sua ordem de compra agora, caso esteja pronta.",
    "PODisclaimer1": "Sua assinatura foi ativada e está pronta para ser utilizada.",
    "PODisclaimer2": "O pagamento deverá ser recebido dentro de 30 dias ou sua conta será automaticamente convertida para uma conta gratuita na comunidade.",
    "POStartsLaterDisclaimer": "Enviaremos sua fatura em <strong>{{date}}</strong>, quando seu novo plano começar. O pagamento vence em até 30 dias a partir dessa data."
  },
  "legal": {
    "privacyPolicy": "Política de Privacidade",
    "studentPolicy": "Política de dados do aluno",
    "termsAndConditions": "Termos e Condições",
    "termsOfService": "Termos de Serviço",
    "tdTermsAndConditions": "Concordo com os <1>$t(legal.termsAndConditions) da Tobii Dynavox</1>",
    "contactUs": "Contate-nos"
  },
  "errors": {
    "error": "Erro",
    "loadingPlans": "Carregando planos",
    "sorry": "Sentimos muito... Não é você, somos nós.",
    "somethingWentWrong": "Algo de nossa parte deu errado. Registramos o erro e pedimos que você <1>{{link}}</1> com a máximo urgência caso encontre esse problema novamente.",
    "tryGoingBack": "Tente o botão \"voltar\" ou <1>{{link}}</1>",
    "downloadList": "Não foi possível carregar a lista de downloads."
  },
  "404": {
    "sorry": "Desculpe... não conseguimos encontrar essa página",
    "oldLink": "O link pode ser antigo ou ter sido removido.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Comece seu teste grátis agora!",
    "startYourFreeTrial": "Comece seu teste grátis",
    "todayWhichIncludesAccessForThirtyDays": " hoje mesmo - ele inclui acesso por 30 dias!"
  },
  "navigation": {
    "bmoRedirect": "Redirecionando você para o myBoardmaker..."
  },
  "expired": {
    "expiredTrialText": "Esperamos que você tenha gostado do seu teste de 30 dias sem restrições. Seu teste foi convertido em um plano gratuito na Comunidade e todos os seus dados e progresso* foram salvos. Para acessar os recursos premium disponibilizados durante seu teste, é só atualizar para uma assinatura mensal ou anual.",
    "dataAndProgress": "* Os dados e o progresso contidos nos recursos premium só podem ser acessados com uma assinatura paga completa."
  },
  "currencySelector": {
    "header": "Selecione seu país e idioma",
    "disclaimer": {
      "USD": "Se seu país não estiver na lista, selecione Estados Unidos da América."
    }
  },
  "taxExempt": {
    "us&ca": "Apenas Estados Unidos e Canadá",
    "taxExemptionProgram": "Envie seus documentos de isenção de impostos usando este formulário. Entraremos em contato com você por e-mail dentro de 3 dias úteis para confirmar sua situação com relação à isenção de impostos. Após receber o e-mail de confirmação, você poderá realizar seu pedido livre de impostos. Caso você realize seu pedido antes de receber o e-mail de confirmação, ele incluirá a cobrança de impostos não restituíveis.",
    "taxExemptionProgramExisting": "Envie seus documentos de isenção de impostos usando este formulário. Entraremos em contato com você por e-mail dentro de 3 dias úteis para confirmar sua situação com relação à isenção de impostos. Após receber o e-mail de aprovação, as compras e renovações de assinatura posteriores serão isentas de impostos. Os impostos pagos em compras anteriores ao recebimento do e-mail de confirmação de isenção de taxas não são restituíveis.",
    "yourSubmissionWasSuccessfulNew": "Seu envio foi realizado com sucesso. Nossa equipe analisará sua documentação, e você deverá receber uma notificação por e-mail dentro de 3 dias úteis confirmando o processamento da sua inscrição. Após a aceitação, você poderá concluir seu pedido isento de impostos. Enquanto isso, criamos uma conta gratuita na Comunidade para que você possa começar a explorar tudo o que o myBoardmaker tem a oferecer.",
    "yourSubmissionWasSuccessfulExisting": "Seu envio foi realizado com sucesso. Nossa equipe analisará sua documentação, e você deverá receber uma notificação por e-mail dentro de 3 dias úteis confirmando o processamento da sua inscrição. Após a aceitação, você poderá concluir seu próximo pagamento isento de impostos."
  },
  "modify": {
    "contactCustomerSupport": "Entre em contato com <1>{{supportLink}}</1> para alterar sua assinatura",
    "billingDetails": "Alterar detalhes de faturamento",
    "paymentModalHeader": "Atualização realizada com sucesso!",
    "paymentModalBody": "Suas alterações serão aplicadas no seu próximo ciclo de faturamento.",
    "thankYou": "Agradecemos o seu pagamento!",
    "daysRemaining": "dias restantes",
    "dueDisclaimer": "Caso o pagamento não seja recebido dentro de 30 dias após a data de renovação, sua conta será transformada em uma conta gratuita na comunidade até a efetuação do pagamento.",
    "lateDisclaimer": "Para evitar a interrupção da sua assinatura, pague o valor total da sua fatura. Caso o pagamento não seja recebido, sua conta será transformada em uma conta gratuita na comunidade até a efetuação do pagamento.",
    "nextPaymentDueIn": "O próximo pagamento vencerá em",
    "days": "dias",
    "paymentIs": "O pagamento está",
    "daysPastDue": "dias atrasado",
    "recurringPaymentDisclaimer": "Seu <1>planOrOrder</1> inclui um <strong>pagamento recorrente</strong> no valor de <4> que será renovado em {{amount}}</4> <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Seu plano inclui um <strong>pagamento recorrente</strong> que será renovado em <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Você pode enviar sua ordem de compra utilizando um dos métodos descritos abaixo. Entre em contato com nossa equipe de atendimento ao cliente para reativar sua assinatura.",
    "yourAccountHasBeenConverted": "Sua conta paga é transformada em uma conta gratuita na comunidade",
    "balanceDueIn": "Vencimento da fatura em",
    "subscriptionExpiresIn": "A assinatura expira em",
    "paymentPastDue": "Pagamento atrasado",
    "autoRenewal": "Renovação automática",
    "turnAutoRenewOff": {
      "header": "Desativar a renovação automática da assinatura",
      "areYouSure": "Tem certeza de que deseja desativar a renovação automática? Prosseguir fará o seguinte:",
      "points": [
        "Cancelar sua assinatura paga ao fim do seu ciclo de faturamento atual.",
        "Transformar sua conta em um plano gratuito da Comunidade ao fim do seu ciclo de faturamento.",
        "Você poderá acessar seu conteúdo após a conversão e poderá assinar novamente a qualquer momento para voltar a acessar os recursos premium das assinaturas pagas. ",
        "Caso mude de ideia antes do final da assinatura, reative sua renovação automática."
      ],
      "footer": "Gostaria de desativar a renovação automática?"
    },
    "turnAutoRenewOn": {
      "header": "Ativar a renovação automática da assinatura",
      "areYouSure": "A renovação automática de assinatura oferece:",
      "points": [
        "A sua assinatura será renovada automaticamente quando o período de assinatura atual terminar.",
        "Pagamento fácil utilizando seu método de pagamento armazenado.",
        "Enviamos um comprovante por e-mail toda vez que a sua assinatura é renovada.",
        "Como sempre, você pode alterar as configurações da sua assinatura a qualquer momento em Meu Plano.",
        "Mudou de ideia? Desative a renovação automática antes do último dia do período de assinatura atual e você não será cobrado."
      ],
      "footer": "Gostaria de ativar a renovação automática?"
    },
    "on": "Ativado",
    "off": "Desativado",
    "pending": "pendente",
    "plan": "Plano",
    "term": "Termo",
    "effective": "Em vigor",
    "subscription": "Assinatura",
    "downgradeWarning": {
      "title": "Reduzir assinatura",
      "prompt": "Tem certeza de que deseja selecionar este plano? Prosseguir fará o seguinte:",
      "planChange": "Reduzir seu plano de Profissional para Pessoal ao fim do seu ciclo atual de faturamento.",
      "termChange": "Reduzir o período de sua assinatura de Anual para Mensal ao fim do seu ciclo atual de faturamento.",
      "changeNote": "Suas alterações serão aplicadas no seu próximo ciclo de faturamento.",
      "termChangeMultiToYearly": "Reduzir seu plano de mais de um ano para Anual ao fim do seu ciclo atual de faturamento.",
      "termChangeMultiToMonthly": "Reduzir o período de sua assinatura de mais de um ano para Mensal ao fim do seu ciclo atual de faturamento."
    },
    "futureAmendmentThankYou": "Estas alterações entrarão em vigor ao fim do ciclo de cobrança atual. Uma fatura será disponibilizada quando estas alterações forem aplicadas à sua conta. Caso deseje cancelar um pedido pendente, ligue para o <1>atendimento ao cliente</1>.",
    "futureAmendmentDisclaimer": "Seu plano <1>{{planName}}</1>  atual irá expirar em <3>{{startEndDate}}</3>. Seu novo plano <5>{{selectedPlanName}}</5> será iniciado em <7>{{startEndDate}}</7>  e renovado automaticamente em <9>{{term}}</9>.",
    "modificationPending": "Alteração de plano pendente",
    "paymentDeclined": "A transação de renovação da sua assinatura foi rejeitada. Pedimos que altere o seu método de pagamento até <1>{{date}}</1> ou sua assinatura será cancelada.",
    "continueSubscription": "A sua assinatura irá terminar em <1>{{ date1 }}</1>. Se você deseja continuar sua assinatura por mais {{term}}, ative a renovação automática até <5>{{ date2 }}</5> e nós processaremos o seu pagamento no dia seguinte",
    "discontinuedRatePlan": "Seu plano de assinatura atual não está mais disponível. Selecione outra opção.",
    "cancelYourSubscription": "Caso deseje cancelar a sua assinatura e receber um reembolso total, entre em contato com <1>{{supportLink}}</1> antes de <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Modificar assinatura",
    "cancelCardText": "Você pode cancelar sua assinatura a qualquer momento. Mas adoraríamos que você ficasse.",
    "cancelConfirmTitle": "Tem certeza de que deseja cancelar sua assinatura?",
    "cancelConfirmIntro": "Seu plano atual permanecerá ativo até <strong>{{date}}</strong>. Depois que seu plano terminar:",
    "cancelConsequences": [
      "Você perderá o acesso aos recursos premium.",
      "Você perderá os benefícios exclusivos disponíveis com sua assinatura.",
      "Os benefícios da sua assinatura terminarão quando seu plano atual expirar."
    ],
    "keepSubscription": "Manter minha assinatura",
    "confirmCancel": "Não, quero cancelar",
    "cancelledTitle": "Sua assinatura foi cancelada!",
    "cancelledBody": "Sua assinatura foi cancelada. Você não terá acesso à sua conta premium após {{date}}.",
    "cancelledFarewell": "Sentimos muito pela sua saída! Você pode voltar quando quiser.",
    "done": "Concluído",
    "cancelledNotice": "Seu plano <strong>{{planName}}</strong> atual expirará em <strong>{{date}}</strong>. Renove sua assinatura para continuar aproveitando nossos recursos premium.",
    "resubscribedNotice": "Seu novo plano <strong>{{planName}}</strong> começa em <strong>{{date}}</strong>, quando o atual expirar."
  },
  "tdAccount": {
    "title": "Conta Tobii Dynavox",
    "header": "O que é uma conta Login Único (SSO) Tobii Dynavox?",
    "body": "Sua conta Tobii Dynavox SSO, composta por um endereço de e-mail e senha, é sua conta única para fazer login em qualquer um dos nossos sites ou aplicativos. Juntamente com os benefícios aprimorados de segurança, a conta SSO fornece acesso mais rápido e conveniente ao seu conteúdo em todos os serviços Tobii Dynavox.",
    "haveA": "Já tem uma",
    "tobiiDynavoxAccount": "conta Tobii Dynavox?"
  },
  "redirectPageTitle": {
    "homePage": "Página inicial",
    "profileCreation": "Criar perfil"
  },
  "download": {
    "downloadBoardmaker": "Baixar Boardmaker",
    "downloadBoardmakerStudentCenter": "Baixar Boardmaker Student Center",
    "downloadOtherVersions": "Baixar outras versões",
    "downloadBoardmakerStudio": "Baixar Boardmaker Studio",
    "licenseKey": "Chave Licença",
    "download": "Baixar",
    "licenseHelper": "Gerenciador de licenças",
    "discontinued": "Descontinuado em <1>{{discontinueDate}}</1>. Consulte <3>requisitos do sistema</3>.",
    "communityStartHeader": [
      "Solicite seu acesso e armazenamento na Comunidade",
      0,
      0
    ],
    "communityStartBody": [
      "O Boardmaker foi projetado para funcionar com o Boardmakeronline.com, onde você pode guardar cópias dos seus arquivos pessoais do Boardmaker e acessar nossa comunidade global de forma segura. Os membros da comunidade podem compartilhar suas criações e encontrar novas atividades de outros usuários do Boardmaker. Cadastre uma conta gratuita na Comunidade para acessar!",
      0,
      0
    ],
    "latestMobile": "Para obter a melhor experiência, tente baixar o software de um dispositivo que atenda aos <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "requisitos do sistema",
    "viewSystemRequirements": "Consulte o <1>{{guideLink}}</1> para obter os requisitos do sistema.",
    "onThisPage": "Nesta página",
    "communityStart": {
      "header": "Solicite seu acesso e armazenamento na Comunidade",
      "body": "O Boardmaker foi projetado para funcionar com myboardmaker.com. Sua conta gratuita na Comunidade Boardmaker inclui:",
      "pointOne": "Armazenamento em nuvem - faça backup com segurança de seus arquivos pessoais do Boardmaker e acesse-os em qualquer lugar!",
      "pointTwo": "Activities-to-Go - Currículo temático nivelado pronto para ser impresso e usado.",
      "pointThree": "Acesso à nossa comunidade global - compartilhe o que você criou e encontre novas atividades do Boardmaker de outros usuários.",
      "footer": "Cadastre sua conta gratuita na Comunidade para acessar!"
    },
    "BoardmakerCompatible": "Este dispositivo não é compatível com o software Boardmaker.",
    "BoardmakerStudentCenterCompatible": "Este dispositivo não é compatível com o aplicativo Boardmaker Student Center.",
    "BoardmakerMobile": "Os aplicativos do Boardmaker não são compatíveis com este dispositivo.",
    "mainFeatures": "Recursos principais",
    "compatibility": "Compatibilidade",
    "improvements": "Melhorias",
    "bugFixes": "Correções de bugs",
    "version": "Versão",
    "discontinuedSupport": "Suporte descontinuado",
    "releaseDate": "Lançado {{date}}",
    "discontinuedDate": "Descontinuado {{date}}",
    "boardmakerSummary": "Selecione o botão abaixo para baixar a versão mais recente do Boardmaker Editor, que é utilizado para criar e editar atividades.  O instalador funciona com todos os tipos de conta e idiomas compatíveis.",
    "studentCenterSummary": "Selecione o botão abaixo para baixar a versão mais recente do Boardmaker Student Center, que é utilizado para reproduzir as atividades do Boardmaker. O instalador funciona com todos os tipos de conta e idiomas compatíveis.",
    "boardmakerIntro": "O Boardmaker 7 Editor é a principal ferramenta para ajudar educadores, terapeutas e pais a criar, editar e compartilhar atividades do Boardmaker.  Apoie o aprendizado e a comunicação em sua sala de aula, sala de terapia ou em casa com uma grande quantidade de material personalizável.",
"studentCenterIntro": "Quando associados a certos tipos de assinaturas do Boardmaker 7, os professores podem atribuir atividades aos alunos no aplicativo Boardmaker 7 Student Center e acompanhar o progresso.  Os alunos podem usar o aplicativo em casa ou na escola para realizar suas atividades.",
"boardmakerStudioIntro": "O Boardmaker Studio permite que pessoas que apoiam alunos com deficiência criem e editem atividades para ajudá-los a aprender e se comunicar usando símbolos, texto e fala sintética e gravada.",
"mobilePlayerIntro": "Quando associados a certos tipos de assinaturas do myBoardmaker, os professores podem atribuir atividades aos alunos no aplicativo Boardmaker Student Center e acompanhar o progresso.  Os alunos podem usar o aplicativo em casa ou na escola para realizar suas atividades."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "assinatura",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "licença",
      "tolicenseText": "compra única",
      "mainText": "Prefere um(a) <1>{{ toggleText }}</1> or <3>{{ helpLink }}</3>?",
      "preferencedText": "Prefere um(a) "
    },
    "comparison": {
      "accessTo": "Acesso ao seguinte...",
      "title": "Ajude-me a escolher",
      "titleDescription": "Uma comparação rápida entre a Assinatura do myBoardmaker e o Software Boardmaker por si só.",
      "titles": {
        "investment": "Investimento",
        "includedSoftware": "Software incluso",
        "softwareUpdates": "Atualizações de Software",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Armazenamento em nuvem",
        "curriculum": "Currículo escolar",
        "studentManagement": "Gerenciador de alunos"
      },
      "subscription": {
        "header": "Assinatura do myBoardmaker",
        "investment": "Baixo custo inicial, opções de pagamento mensal ou anual",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Incluso (2-3 vezes por ano)",
        "pcsSymbols": "Todos os símbolos, incluindo símbolos novos a cada 2 semanas",
        "cloudStorage": [
          "Armazenamento de atividades",
          "Armazenamento de arquivos"
        ],
        "curriculum": [
          "Boardmaker Activities to Go 10 temas x 4 unidades cada",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": ["Passar atividades\u00B9", "Monitorar desempenho"]
      },
      "license": {
        "header": "Apenas software",
        "investment": "Compra única do software",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Atualizações pagas periodicamente (a cada 2-3 anos)",
        "pcsSymbols": "Todos os símbolos disponíveis no momento do lançamento mais recente (assinatura do PCS em breve)",
        "cloudStorage": ["Armazenamento de atividades"],
        "curriculum": ["Boardmaker Activities to Go 1 tema x 4 unidades "],
        "studentManagement": ["Nenhum"]
      },
      "note": "Os usuários podem gerenciar e adicionar tarefas individuais no plano de assinatura Profissional.",
      "note2": "Só pode ser acessado com o Student Center Player",
      "note3": "Os usuários podem gerenciar e adicionar tarefas individuais no plano de assinatura Profissional.",
      "localizationNoteOne": "Os aplicativos Boardmaker 7 estão disponíveis nos idiomas a seguir para usuários assinantes e usuários apenas do software.",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Inglês (EUA)",
        "Espanhol",
        "Alemão",
        "Sueco",
        "Finlandês",
        "Russo",
        "Dinamarquês",
        "Norueguês",
        "Francês",
        "Italiano",
        "Polonês",
        "Português"
      ],
      "localizationNoteTwo": "O currículo escolar e o site myBoardmaker.com só estão disponíveis em Inglês."
    }
  },
  "systemRequirements": "Requisitos do Sistema",
  "releaseNotes": "Notas de Lançamento",
  "operatingSystem": {
    "title": "Sistema operacional",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobile)",
    "windows": "Windows",
    "unknown": "Unknown"
  },
  "perpetual": {
    "trial": {
      "intro": "Sem cartão de crédito. Sem compromisso. Apenas <1>{{trialLength}}</1> dias consecutivos de acesso irrestrito ao nosso mais recente software Boardmaker. Após baixar e instalar o software no seu computador, você poderá solicitar uma chave de ativação para <3>{{trialLength}}</3>- dia(s)<5>*</5> de dentro do software.",
      "footnote": "<0>*</0>Os testes começam no dia em que seu software é ativado e permanecem ativos por <2>{{trialLength}}</2> dias consecutivos.",
      "downloadFootnote": "<0>v{{version}}</0> inclui os recursos e correções mais recentes. Consulte <2>requisitos do sistema</2>."
    },
    "thankyou": {
      "intro": "Procure seu e-mail de confirmação do pedido, que contém os links para download do Boardmaker e sua chave de ativação. Nós também fornecemos as informações abaixo. Baixe e instale o Boardmaker em seu computador, e use a chave de ativação para ativar seu software. Após a ativação, você receberá 1 ano de atualizações gratuitas. <1>Certifique-se de salvar sua chave de ativação para usos futuros.</1>"
    },
    "latest": "Mais recente",
    "legacy": "Antigo"
  },
  "countries": {
    "us": "Estados Unidos da América"
  },
  "currencyChange": {
    "header": "Câmbio",
    "body": "Neste momento, as Assinaturas não podem ser compradas utilizando a moeda do país selecionado. Se decidir prosseguir, a moeda será alterada para dólares americanos - USD."
  },
  "partner": {
    "body": "O parceiro selecionado, ou fornecedor de suporte, será seu contato principal para todas as dúvidas e problemas técnicos relacionados ao seu produto.",
    "contactUs": "Se o país listado não estiver correto,  ",
    "contactCustomerService": "entre em contato com o atendimento ao cliente."
  }
}
